import { Net } from '@/utils/axios';

export interface NameSuggestResp {
  isName: boolean;
  suggestName: string;
}

export const getNameSuggest = async (name: string): Promise<NameSuggestResp>=>{
  return Net.get(`/name/suggest?name=${name}`);
};